import { render } from "./DocumentsModal.vue?vue&type=template&id=7906b3ee&scoped=true"
import script from "./DocumentsModal.vue?vue&type=script&lang=js"
export * from "./DocumentsModal.vue?vue&type=script&lang=js"

import "./DocumentsModal.vue?vue&type=style&index=0&id=7906b3ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7906b3ee"]])

export default __exports__